export default __webpack_public_path__ + "static/media/dog.ea0b4cf5.svg";